import './WordSearchGrid.css';

import React from 'react';

const Header = (props) => <div><header className="header">
    <h1>Wellcome to the word search webpage</h1>
                            </header></div>

export default Header;